import { Skeleton, type SkeletonProps } from "@akuna/ui";
import { useTranslation } from "react-i18next";

export type LoadingSkeletonProps = Omit<SkeletonProps, "label"> & {
  label?: string;
};

export function LoadingSkeleton({ label, ...props }: LoadingSkeletonProps) {
  const { t } = useTranslation("common");

  return <Skeleton {...props} label={label ?? t("loading")} />;
}
